export default __webpack_public_path__ + "static/media/logo-icon.9e2d7d67.svg";